import React from 'react'
import { FieldHookConfig, useField } from 'formik'
import { TimePicker as UITimePicker } from '@carsys/ui'
import { isInvalid } from './utils'
import DateType from '@carsys/ui/src/date-helpers/date-type'
import { apiFormat } from '@cbgms/base/utils/datetime'
import moment from 'moment'
import { useRegisterFormField } from './TabbedForm/FormTabPanel'

interface DateTimePickerProps
  extends Omit<React.ComponentProps<typeof UITimePicker>, 'name'>,
    Pick<FieldHookConfig<string>, 'name' | 'validate'> {}

export function TimePicker({ name, validate, ...props }: DateTimePickerProps) {
  const [input, meta, helpers] = useField<string>({ name, validate })
  useRegisterFormField(name)

  // use api format because form components are meant to submit their value to the api
  const timeFormat = apiFormat.time

  const onChange = (date: DateType) => {
    // Don't run validation on partial input, only when valid or on blur
    helpers.setValue(date ? date.format(timeFormat) : '', date?.isValid())
  }

  return (
    <UITimePicker
      {...props}
      value={moment(input.value ?? '00:00', timeFormat)}
      onChange={onChange}
      slotProps={{
        ...props.slotProps,
        textField: {
          id: input.name,
          name: input.name,
          onBlur: input.onBlur,
          error: isInvalid(meta),
          // @ts-ignore Fix typescript does not exist error for helperText
          // see: https://github.com/mui/mui-x/issues/8026
          helperText: isInvalid(meta) ? meta.error : props.slotProps?.textField?.helperText,
          ...props.slotProps?.textField
        }
      }}
    />
  )
}
